import { Message } from 'element-ui'
import { $t } from '@/i18n'

export const handlePostAction = async ({
  commit,
  action,
  params = {},
  successMessage,
  errorMessage = 'error.found'
}) => {
  try {
    const response = await action(params)
    if (response.id) {
      Message({
        type: 'success',
        message: $t(successMessage, params)
      })
      return response
    }
    if (response.ad && response.ad.id) {
      Message({
        type: 'success',
        message: $t(successMessage, params)
      })
      return response
    }
    if (response.type == 'error') {
      Message({
        type: 'error',
        message: response.message
      })
      return response
    }
    return { type: 'error' }
  } catch (error) {
    console.error('Error in post action:', error)
    Message({
      type: 'error',
      message: $t(errorMessage)
    })
    return { type: 'error' }
  }
}
